<template>
  <div class="w-100">
    <h1>Report</h1>

    <div class="row mt-4">
            <div class="col-lg-3">
              <label for="type">Report period :</label>
              <select v-model="inputFilters.type" id="type" class="form-control">
                <option selected value="weekly">Last week</option>
                <option value="monthly">Monthly</option>
                <option value="yearly">Yearly</option>
              </select>
            </div>
      <div class="col-lg-3">
        <label for="date-datepicker">Filter by date:</label>
        <date-picker
            v-model="inputFilters.date"
            id="date-datepicker"
            locale="en"
            format="YYYY-MM-DD"
            range
            clearable
            color="#f42f4b"
        />
      </div>
      <div class="col-lg-2">
        <label class="d-block" style="visibility: hidden">Filter</label>
        <button class="btn btn-primary" @click="filter">
          <i class="fas fa-search"></i>
        </button>
        <button
            v-if="! chartLoaded"
            class="btn btn-info ml-2"
            title="Show in chart"
            @click="showChart"
        >
          <i class="fa fa-chart-bar"></i>
        </button>
        <button
            v-if="chartLoaded"
            class="btn btn-warning ml-2"
            title="Remove chart"
            @click="removeChart"
        >
          <i class="fa fa-eye-slash"></i>
        </button>
      </div>
    </div>

    <div v-if="chartLoaded">
      <div id="chart">
        <apexchart type="bar" height="350" :key="chartKey" :options="chartOptions" :series="series"></apexchart>
      </div>
    </div>
    <div v-else>
      <div class="table-responsive">
        <table class="table mt-2">
          <thead class="thead-light">
          <tr>
            <th scope="col">Date</th>
            <th scope="col">Customer(online)</th>
            <th scope="col">Offline(By Admin)</th>
            <th scope="col">Agency(connect)</th>
            <th scope="col">Corporate</th>
            <th scope="col">Seller</th>
          </tr>
          </thead>
          <tbody>
          <!--          <router-link tag="tr" :to="{ name: 'cart.show', params: {id: cart.id}}" v-for="cart in items" v-bind:key="cart.id" style="cursor:pointer;">-->
          <tr v-if="sales.length === 0">
            <td style="color: darkred" colspan="5">Data not available, change your date filter</td>
          </tr>
          <tr v-else  v-for="sale in sales">
            <td>{{ sale.date ?? sale.month ?? sale.year }}</td>
            <td>{{ sale.customer_buy_count }}</td>
            <td>{{ sale.offline_buy_count }}</td>
            <td>{{ sale.agency_buy_count }}</td>
            <td>{{ sale.corporate_buy_count }}</td>
            <td>{{ sale.seller_buy_count }}</td>
          </tr>

          <!--          </router-link>-->
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import {config} from "@/helpers";
import multiselect from "vue-multiselect";

export default {
  components: {multiselect},
  data() {
    return {
      myData : {},
      chartKey: Date.now(),
      url         : "",
      inputFilters: {
        type: '',
        date: ''
      },
      isFiltered  : false,
      filters     : {},
      sales: [],
      chartLoaded: false,
      series: [],
      chartOptions: {
        chart: {
          type: 'bar',
          height: 350,
          stacked: true,
          stackType: '100%'
        },
        plotOptions: {
          bar: {
            horizontal: true,
          },
        },
        stroke: {
          width: 1,
          colors: ['#fff']
        },
        title: {
          text: ''
        },
        xaxis: {
          categories: []
        },
        tooltip: {
          y: {
            formatter: function (val) {
              return val
            }
          }
        },
        fill: {
          opacity: 1

        },
        legend: {
          position: 'top',
          horizontalAlign: 'left',
          offsetX: 40
        }
      },
    };
  },
  mounted() {
    this.url = config("BACKEND_ROOT") + "/admin/statistic";
    this.generateFilter();
    this.getStatisticReport();
  },
  methods: {
    filter(){
      this.generateFilter();
      this.getStatisticReport();
    },
    async getStatisticReport() {
      await axios.get(this.url + "/report/share", {params: this.myData}).then((response) => {

        this.sales = response.data.data.statistics;

        Object.assign(this.chartOptions.xaxis.categories, []);
        Object.assign(this.chartOptions.xaxis.categories, response.data.data.dates)
        this.series = [];
        this.series = response.data.data.series;
      });
    },
    generateFilter(){
      this.isFiltered = true;
      let filters = {};

      if (this.inputFilters.date[0]) {
        filters.date = {};
        filters.date.start = this.inputFilters.date[0];
        filters.date.end = this.inputFilters.date[1];
      }
      else{
        filters.date = '';
      }

      if (this.inputFilters.type) {
        filters.period = this.inputFilters.type;
      }

      this.filters = filters;

      if (this.isFiltered) {
        let filters = this.filters;
        this.myData = {...this.myData,...filters };

      }
    },
    showChart(){
      this.chartLoaded = true;
    },
    removeChart(){
      this.chartLoaded = false;
    }
  }

}
</script>

<style scoped>

</style>